import React from 'react';
import './Skills.css';

function Skills() {
  const skillCategories = [
    {
      title: 'Cloud Platforms',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <path d="M25 10 Q 20 10 20 15 Q 10 15 10 25 Q 10 35 20 35 L 40 35 Q 45 35 45 30 Q 45 25 40 25 Q 40 15 30 15 Q 30 10 25 10" 
                stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="25" cy="25" r="5" fill="currentColor"/>
        </svg>
      ),
      skills: ['AWS (EKS, CodePipeline)', 'Azure (OpenAI)', 'GCP (Vertex AI, GKE)', 'CloudWatch']
    },
    {
      title: 'Containers & Orchestration',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <rect x="10" y="10" width="30" height="30" rx="2" stroke="currentColor" strokeWidth="2"/>
          <rect x="15" y="15" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
          <circle cx="25" cy="25" r="5" fill="currentColor"/>
        </svg>
      ),
      skills: ['Kubernetes (EKS, GKE)', 'Docker', 'Helm', 'ArgoCD']
    },
    {
      title: 'CI/CD & GitOps',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <circle cx="15" cy="25" r="8" stroke="currentColor" strokeWidth="2"/>
          <circle cx="35" cy="25" r="8" stroke="currentColor" strokeWidth="2"/>
          <path d="M 23 25 L 27 25" stroke="currentColor" strokeWidth="2"/>
          <path d="M 15 17 L 15 10 M 35 17 L 35 10 M 15 33 L 15 40 M 35 33 L 35 40" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      skills: ['ArgoCD', 'Bitbucket Pipelines', 'AWS CodePipeline', 'GitLab CI']
    },
    {
      title: 'Infrastructure as Code',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <path d="M 10 25 L 25 10 L 40 25 L 25 40 Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M 20 25 L 25 20 L 30 25 L 25 30 Z" fill="currentColor"/>
        </svg>
      ),
      skills: ['Terraform', 'Helm Charts', 'CloudFormation', 'Infrastructure Automation']
    },
    {
      title: 'Observability Stack',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <rect x="5" y="30" width="8" height="15" fill="currentColor"/>
          <rect x="17" y="20" width="8" height="25" fill="currentColor"/>
          <rect x="29" y="25" width="8" height="20" fill="currentColor"/>
          <rect x="41" y="15" width="8" height="30" fill="currentColor"/>
          <path d="M 8 25 L 21 15 L 33 20 L 45 10" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      ),
      skills: ['Prometheus', 'Grafana', 'Loki', 'Tempo']
    },
    {
      title: 'Security & IT Operations',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <path d="M 25 5 L 40 12 L 40 25 Q 40 35 25 45 Q 10 35 10 25 L 10 12 Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M 20 25 L 23 28 L 30 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      skills: ['Zscaler Zero Trust', 'Microsoft Defender', 'IAM', 'Intune/SCCM']
    },
    {
      title: 'AI/ML & Scripting',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <circle cx="25" cy="25" r="15" stroke="currentColor" strokeWidth="2"/>
          <circle cx="25" cy="25" r="5" fill="currentColor"/>
          <path d="M 25 10 L 25 5 M 25 40 L 25 45 M 10 25 L 5 25 M 40 25 L 45 25" stroke="currentColor" strokeWidth="2"/>
          <circle cx="25" cy="10" r="2" fill="currentColor"/>
          <circle cx="25" cy="40" r="2" fill="currentColor"/>
          <circle cx="10" cy="25" r="2" fill="currentColor"/>
          <circle cx="40" cy="25" r="2" fill="currentColor"/>
        </svg>
      ),
      skills: ['Vertex AI', 'Azure OpenAI', 'Python', 'Bash']
    },
    {
      title: 'ITSM & Collaboration',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <circle cx="15" cy="15" r="5" stroke="currentColor" strokeWidth="2"/>
          <circle cx="35" cy="15" r="5" stroke="currentColor" strokeWidth="2"/>
          <circle cx="25" cy="35" r="5" stroke="currentColor" strokeWidth="2"/>
          <path d="M 18 18 L 23 30 M 32 18 L 27 30" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      skills: ['Freshservice', 'ITIL Processes', 'Git', 'Microsoft 365']
    },
     {
      title: 'IT Consulting & Advisory',
      icon: (
        <svg viewBox="0 0 50 50" fill="none">
          <path 
            d="M10 35 L25 10 L40 35" 
            stroke="currentColor" 
            strokeWidth="2" 
            fill="none"
          />
          <circle cx="25" cy="32" r="3" fill="currentColor" />
        </svg>
      ),
      skills: [
        'IT Infrastructure Architecture',
        'Technology Roadmap & Planning',
        'System Design & Scalability',
        'IT Governance & Best Practices',
        'SME Technology Advisory'
      ]
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title">
          <span className="section-number"></span>Skills & Technologies</h2>
    
          <p className="section-subtitle">
            Hands-on engineering experience combined with technology consulting and IT advisory
            for scalable, reliable, and secure systems. <br />
          </p>
        
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-card" style={{animationDelay: `${index * 0.1}s`}}>
              <div className="skill-icon">
                {category.icon}
              </div>
              <h3 className="skill-title">{category.title}</h3>
              <div className="skill-list">
                {category.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;

